/**
 * Runtime environment detection.
 *
 * `isNativeOrInstalledApp()` returns true iff the current page is running in:
 *   - The Capacitor native WebView (Android/iOS app), OR
 *   - An installed PWA (Android display-mode: standalone, or iOS home-screen).
 *
 * Returns false for every plain browser tab. This is the single source of
 * truth for gating "app-only" behaviours like the biometric unlock screen,
 * so email-link visitors on Chrome never get trapped in a passkey loop.
 *
 * Bug fixed (Feb 2026): venue outreach emails link to allurexp.com/for-venues.
 * Users who had previously used the Allure PWA on the same origin still had
 * `allure_has_passkey=true` in localStorage, which routed browser visitors
 * to /unlock and popped the OS passkey picker in a loop. Guarding both
 * /unlock redirects with this helper stops the loop.
 */
export const isNativeOrInstalledApp = () => {
  try {
    if (typeof window === 'undefined') return false;
    const cap = window.Capacitor;
    if (cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform()) return true;
    if (window.navigator && window.navigator.standalone === true) return true;
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) return true;
  } catch (_e) { /* noop */ }
  return false;
};
